import React, { memo, useState } from "react";
import Chip from "@material-ui/core/Chip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { StyledTextField } from "./styles";
import { isGloboCurrentApp } from "../../utils/get-app-env";
import { makeStyles } from "@material-ui/core";

type FieldProps = {
  options: Array<any>;
  userValue: any[];
  setUserValue: React.Dispatch<React.SetStateAction<any[]>>;
  textValue: string;
  setTextValue: React.Dispatch<React.SetStateAction<string>>;
  inputLabel: string;
  noOptionsText?: string;
  customRef?: any;
  userRole?: string;
  onSelect?: (value: any) => void;
};

const useStyles = makeStyles(() => ({
  autocomplete: {
    width: "90%", // Definir um tamanho fixo
  },
  textField: {
    width: "100%",
    minHeight: "56px", // Ajuste para manter tamanho uniforme
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "4px", // Evita que os chips fiquem desorganizados
  },
}));

const AutocompleteCustomField = memo(
  ({
    options,
    userValue,
    setUserValue,
    textValue,
    setTextValue,
    inputLabel,
    noOptionsText,
    customRef,
    userRole,
    onSelect,
  }: FieldProps) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);

    return (
      <Autocomplete
        className={classes.autocomplete}
        multiple
        ref={customRef}
        value={userValue}
        noOptionsText={noOptionsText}
        autoHighlight
        filterSelectedOptions
        disableCloseOnSelect
        open={open} // Controlado pelo estado
        onOpen={() => {
          if (userValue.length < 2) setOpen(true);
        }}
        onClose={() => setOpen(false)}
        onFocus={() => {
          if (userValue.length < 2) setOpen(true);
        }}
        onChange={(_, newValue) => {
          if (newValue.length <= 2) {
            if (onSelect) {
              onSelect(newValue);
            }
            setUserValue(newValue);
          }
        }}
        inputValue={textValue}
        getOptionLabel={(option) =>
          userRole === "ROLE_ADMIN" ? option.nameLabel : option.label
        }
        onInputChange={(_, newInputValue) => {
          if (userValue.length < 2) {
            setTextValue(newInputValue);
          }
        }}
        id={`autocomplete-multiple-${Math.random()}`}
        options={options}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option.label}
              {...getTagProps({ index })}
            />
          ))
        }
        renderOption={(option) => (
          <React.Fragment>
            {isGloboCurrentApp() ? (
              <span>{option.label}</span>
            ) : (
              <span className="mp-autocomplete-fragment">{option.label}</span>
            )}
          </React.Fragment>
        )}
        renderInput={(params) => (
          <StyledTextField
            {...params}
            label={inputLabel}
            variant="outlined"
            placeholder="Escolher até 2 praça"
          />
        )}
      />
    );
  }
);

export default memo(AutocompleteCustomField);
